import Handlebars from "handlebars";

Handlebars.registerHelper("equal", function (lvalue, rvalue, options) {
  if (lvalue !== rvalue) {
    return options.inverse(this);
  }
  return options.fn(this);
});
